// extracted by mini-css-extract-plugin
export default {"bg":"Layout_bg__xeF-3","root":"Layout_root__827Os","main":"Layout_main__1RsEz","mainCollapsed":"Layout_mainCollapsed__eiFxX"};